export default {
  data() {
    return {
      touchmoveHandler: null,
    }
  },
  mounted() {
    // Check if drag direction was right and trigger back
    let xDown = null;
    let yDown = null;
    this.touchmoveHandler = (e) => {
      if (!xDown || !yDown || xDown > 30) return;
      let xDiff = xDown - e.touches[0].clientX;
      let yDiff = yDown - e.touches[0].clientY;

      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        if (yDiff < 5) {
          if (xDiff < -50) {
            this.back();
            this.$el.removeEventListener('touchmove', this.touchmoveHandler);
          }
        }
      }
    }
    this.$el.addEventListener('touchstart', e => {
      xDown = e.touches[0].clientX;
      yDown = e.touches[0].clientY;
    });
    this.$el.addEventListener('touchmove', this.touchmoveHandler);
    this.$el.addEventListener('touchend', e => {
      xDown = null;
      yDown = null;
    });
  },
  beforeDestroy() {
    this.$el.removeEventListener('touchmove', this.touchmoveHandler);
  },
}



// WEBPACK FOOTER //
// ./src/mixins/SubPageUtils.js